import { runDemo } from "../shared/demoRunner";
import { createHillValleyScene } from "./scene";

runDemo({ createScene: createHillValleyScene });
